/**
 * 模块相关帮助类
 */

import { routes } from './RouteConfig';
import { routes as baselineRoutes } from './baseline/RouteConfig';

const routeMap = {};

const init = () => {
  baselineRoutes.forEach((route) => {
    route.subRoutes.forEach((subRoute) => {
      if (subRoute.subRoutes) {
        subRoute.subRoutes.forEach((subRoute2) => {
          routeMap[route.path + subRoute.path + subRoute2.path] = { hasFlag: true, component: subRoute2.component };
        });
      } else {
        routeMap[route.path + subRoute.path] = { hasFlag: true, component: subRoute.component };
      }
    });
  });
  routes.forEach((route) => {
    route.subRoutes.forEach((subRoute) => {
      if (subRoute.subRoutes) {
        subRoute.subRoutes.forEach((subRoute2) => {
          routeMap[route.path + subRoute.path + subRoute2.path] = { hasFlag: true, component: subRoute2.component };
        });
      } else {
        routeMap[route.path + subRoute.path] = { hasFlag: true, component: subRoute.component };
      }
    });
  });
};

init();

export function loadViewComponent(url) {
  let newUrl = url;
  // 平台sysConfig模块路由兼容
  if (url.includes('./')) {
    const newUrlStr = url.replace('./', '');
    const routerArr = newUrlStr.split('/');
    if (routerArr.length && routerArr.length > 2) {
      newUrl = '/' + routerArr[0] + '/' + routerArr[2];
    } else {
      return null;
    }
  }
  var componentInfo = routeMap[newUrl];

  if (componentInfo && componentInfo.hasFlag) {
    return componentInfo.component;
  } else {
    return null;
  }
}
